<template>
  <div> 
    <v-app-bar 
      app="" dark=""
      color="white" flat="">
      <v-app-bar-nav-icon color="black" @click="navOpen()"/> 
      <router-link to="/">
        <v-img   
          class="mx-4" 
          width="150"   
          :src="'/masoathu/logo.png'"
        /> 
      </router-link>
      <!-- <router-link to="/" >
        <v-toolbar-title class="white--text" >{{not.appName}}</v-toolbar-title>
      </router-link> -->
      <v-spacer></v-spacer>  
      <v-btn v-if="!us" to="/login" color="primary" rounded="" outlined >Login</v-btn>

      <div v-else class="primary--text">
        <span class="not-f5">
          {{ud?ud.role:"user"}}
        </span> 
        <v-menu 
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="100"
          offset-x
          >
          <template v-slot:activator="{ on }">
            <v-btn
              icon=""
              class="accent"
              dark
              v-on="on" >
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-list>
              <v-list-item>
                <v-list-item-avatar color="accent">
                  <v-icon dark>mdi-account</v-icon>
                </v-list-item-avatar> 
                <v-list-item-content>
                  <v-list-item-title>{{ud?ud.names:"Username"}}</v-list-item-title>
                  <v-list-item-subtitle>{{us?us.email:"user@mail.com"}}</v-list-item-subtitle>
                </v-list-item-content> 
              </v-list-item>
            </v-list> 
            <v-divider></v-divider> 
            <v-list subheader="">
              <v-subheader>Role: {{ud?ud.role:"user"}}</v-subheader>
              <v-list-item to="/settings/myprofile" @click="menu=false"> 
                <v-list-item-action>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-title>My profile</v-list-item-title>
              </v-list-item>

              <v-list-item @click="not.logout()"> 
                <v-list-item-action>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-action>
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item>
            </v-list> 
          </v-card>
        </v-menu> 
      </div>
    </v-app-bar>  
  </div>
</template>

<script>
export default {
  props:["not"],
  data: () => ({
     menu:false
  }),
  computed: {
    phoneSize(){ 
      let  width = this.not.vs.width 
      if(width<1000){
        return true
      }else{
        return false
      }
    },
    us(){
      return this.not.us
    },
    ud(){
      return this.not.ud
    }
  },
  methods: {
    navOpen(){
      this.$emit("navOpen")
    },
    clicked(){}
  },
};
</script>
